import { GameLiveConnectionMethod } from '../../../services/liveConnection';
import { environmentBuilder } from '../../../core/helpers/environmentBuilder';
import { detectSocketPath } from '../../../core/constants/socketPathName';
import { fishingGameService } from '../fishingService/gameService';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';

export class FishingGameConnection {
  sendCashOut(model) {
    return mainGameConnection.invoke(GameLiveConnectionMethod.CashOut, model);
  }

  executeGameConnections() {
    mainGameConnection.onGetInitialStateResult(
      fishingGameService.onGetInitialStateResult.bind(fishingGameService)
    );
    mainGameConnection.onCashOutResult(
      fishingGameService.handleCashOutResult.bind(fishingGameService)
    );
    mainGameConnection.onReconnected(() => mainGameConnection.sendGameGetInitialState(false));
    mainGameConnection.onBetsClosed(fishingGameService.handleBetsClosed.bind(fishingGameService));
    mainGameConnection.onRoundFinished(fishingGameService.handleRoundFin.bind(fishingGameService));
    mainGameConnection.onDoBetResult(fishingGameService.handleDoBetResult.bind(fishingGameService));
    mainGameConnection.onDoBetResult(
      fishingGameService.handleDoBetResultValidation.bind(fishingGameService)
    );
    mainGameConnection.onBalanceUpdate(
      fishingGameService.handleBalanceUpdate.bind(fishingGameService)
    );
    mainGameConnection.onRoundStarted(fishingGameService.handleRoundStart.bind(fishingGameService));
    mainGameConnection.onResultReport(
      fishingGameService.handleResultReport.bind(fishingGameService)
    );
    mainGameConnection.onDoBetResultValidation(
      fishingGameService.handleDoBetResultValidation.bind(fishingGameService)
    );
  }
}

const { socketUrl } = environmentBuilder(detectSocketPath(window.location.pathname));

export const fishingGameConnection = new FishingGameConnection({ url: `${socketUrl}game` });
